const readNonEmptyString = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
};

export const resolveDisplayName = (source, fallback = 'Forza member') => {
  const resolvedFallback = readNonEmptyString(fallback) || 'Forza member';
  if (!source || typeof source !== 'object') {
    return resolvedFallback;
  }

  const profileData = source.profileData;
  const fullName =
    readNonEmptyString(profileData?.profile?.personalInformation?.fullName)
    || readNonEmptyString(profileData?.personalInformation?.fullName)
    || readNonEmptyString(source.personalInformation?.fullName);

  return (
    fullName
    || readNonEmptyString(source.username)
    || readNonEmptyString(source.email)
    || resolvedFallback
  );
};
